export default __webpack_public_path__ + "static/media/screen4.afded040.png";